import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <footer className="bg-richblack border-t border-white/5" data-testid="footer">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <Link to="/" className="logo-text text-2xl text-white hover:text-gold transition-colors">
              EAGLENCE
            </Link>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Eagle's Vision. Excellence Delivered.
            </p>
            <div className="gold-line" />
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-white font-sans font-semibold text-sm tracking-wider uppercase">
              Quick Links
            </h4>
            <nav className="flex flex-col space-y-3">
              {footerLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-white/50 hover:text-gold text-sm transition-colors duration-300"
                  data-testid={`footer-link-${link.name.toLowerCase()}`}
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Services Preview */}
          <div className="space-y-4">
            <h4 className="text-white font-sans font-semibold text-sm tracking-wider uppercase">
              Our Services
            </h4>
            <nav className="flex flex-col space-y-3">
              <span className="text-white/50 text-sm">Distribution</span>
              <span className="text-white/50 text-sm">Artist Management</span>
              <span className="text-white/50 text-sm">Licensing & Publishing</span>
              <Link 
                to="/services" 
                className="text-gold text-sm hover:text-gold-light transition-colors"
                data-testid="footer-view-all-services"
              >
                View All Services →
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-xs">
            © {currentYear} EAGLENCE. All rights reserved.
          </p>
          <p className="text-white/40 text-xs">
            Music Industry Consultancy
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
